export enum ECRoutesNames {
  CNotFoundPage = 'CNotFoundPage',
  CForbiddenPage = 'CForbiddenPage',
  CSubscriptionsPage = 'CSubscriptionsPage',
  CNotificationsPage = 'CNotificationsPage',
}
